var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLandNorwegen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#e5392e",
    cx: 18,
    cy: 18,
    r: 15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0069b3",
    d: "m18 33c-2.13 0-4.16-.44-6-1.25v-10.75h-8.7c-.2-.97-.3-1.97-.3-3s.1-2.03.3-3h8.7v-10.75c1.83-.8 3.87-1.25 6-1.25v12h14.7c.2.97.3 1.97.3 3 0 1.02-.1 2.03-.3 3h-14.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3,
    d: "m11.85 21.15h-8.55l-.15-.12c-.2-.99-.3-2-.3-3.03s.1-2.04.3-3.03l.15-.12h8.55v-10.6l.09-.14c1.9-.82 3.96-1.26 6.06-1.26l.15.15v11.85h14.55l.15.12c.2 1 .3 2 .3 3.03s-.1 2.05-.3 3.03l-.15.12h-14.55v11.85l-.15.15c-2.11 0-4.16-.43-6.06-1.26l-.09-.14z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandNorwegen);
export default __webpack_public_path__ + "static/media/land_norwegen.46de81d6f687067269b086e72b18f570.svg";
export { ForwardRef as ReactComponent };